import { Alert } from "./alert.web";

export { confirm } from "./alert.web";

/** Web twin of confirm-action's notice: the styled WebAlertHost dialog. */
export interface NoticeOptions {
  title: string;
  message: string;
  okLabel: string;
}

/** A one-button notice in the in-app dialog; resolves once it is dismissed. */
export function notice(options: NoticeOptions): Promise<void> {
  return new Promise((resolve) => {
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      resolve();
    };
    Alert.alert(
      options.title,
      options.message,
      [{ text: options.okLabel, onPress: finish }],
      { cancelable: true, onDismiss: finish },
    );
  });
}
